export default __webpack_public_path__ + "static/media/almost-silent-2.f71de211.mp3";